<template>
    <a class="article-altas" :href="articleData.url" :data-spm-data="templateSpm">
        <h3 class="title">{{articleData.title}}</h3>
        <div class="altas">
            <img class="altas-img" :src="setPicSize(articleData.images[0])" :data-src="preloadImg"/>
            <img class="altas-img" :src="setPicSize(articleData.images[1])" :data-src="preloadImg"/>
            <img class="altas-img" :src="setPicSize(articleData.images[2])" :data-src="preloadImg"/>
        </div>
        <div class="shadow" v-if="articleData.images.length > 3">
            <span class="shadow-info">+ {{articleData.images.length -3}}</span>
        </div>
    </a>
</template>

<script>
import PicUtils from '../../utils/pic-util.js';
export default {
    name: 'ArtAtlas',
    data() {
        return {
            preloadImg: `//47f72d130392f.cdn.sohucs.com/web/static/images/pic/preload.png`
        }
    },
    methods: {
        setPicSize(picUrl) {
            return PicUtils.setPicSize(picUrl, 224, 152, 'c_fill');
        }
    }
}
</script>

<style lang="less" scoped>
    @import '../../less/base/mixins.less';
    .article-altas {
        display: block;
        box-sizing: border-box;
        position: relative;
        padding-top: 22px;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.00);
        border-radius: 6px;
        background: #F0F0F0;
        .title {
            max-height: 88px;
            margin: 0 36px 14px 32px;
            padding-bottom: 0!important;
            font-size: 32px;/*px*/
            line-height: 44px;
            overflow: hidden;
            .line-clamp(2);
            color: #656565;
        }
        .altas {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            height: 152px;
            .altas-img {
                width: 224px;
                height: 152px;
                margin-bottom: 0;
                &:first-child {
                    border-bottom-left-radius: 6px;
                }
                &:last-child {
                   margin-right: 0;
                   border-bottom-right-radius: 6px;
                }
            }
        }
        .shadow {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 224px;
            height: 152px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom-right-radius: 6px;
            background: rgba(0,0,0,0.5);
            .shadow-info {
                font-size: 40px;/*px*/
                color: #ffffff;
            }
        }
    }
</style>

